module.exports = __webpack_public_path__ + "img/NTID.cf606ad0.png";